import { gql } from 'apollo-angular';

export const OutputDeleteByRefNrDocument = gql`
  mutation outputDeleteByRefNr($refNr: String!) {
    outputDeleteByRefNr(refNr: $refNr)
  }
`;
